import { useEffect, useState } from "react"
import apis from "../../../api"
import { apiResult,  getUserSession } from "../../../Utils/Common"
// import { CourseLoader } from "../../fragement/CourseSelector"
// import {  loadCourseCategories } from "../../../Component/DataLoader"
import { CurrencyExchangeOutlined } from "@mui/icons-material"
import { Alert, Box, ButtonGroup, IconButton, Tooltip, Typography } from "@mui/material"
import MyTable from "../../../Component/MyTable"
import CourseOrderRefund from "./CourseOrderRefund"
import { RightDrawer } from "../../../Component/MuiEx"
const CourseOrder = (props)=>{
    const {memberid,coursepackageid,title,onRefunded} = props
    getUserSession(apis)
    const [error,setError]= useState()
    const [rightDrawer, setRightDrawer] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    const [hintMsg, setHintMsg] = useState()
    const [orders,setOrders] = useState()
    const loadData = ()=>{
        apis.membercourseorderGet(memberid,coursepackageid ).then(ret=>{
            apiResult(ret,data=>{
                setOrders(data)
            },setError)
        })
    }
    useEffect(()=>{
        loadData()
    },[memberid,coursepackageid])
    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleRefundSubmit = ()=>{
        setRightDrawer()
        loadData()
        onRefunded && onRefunded()
    }
    const handleRefund = (idx,item)=>{
        setAutoCloseRightDraw(false)
        setRightDrawer(<CourseOrderRefund item={item} onSubmit={handleRefundSubmit} onClose={()=>setRightDrawer()} />)
    }
    const TableHeader = [
        { name: 'id', showName: 'ID' },
        { name: 'create_time', showName: 'Date',func:(v,idx,item)=>{
            return v.substring(0,10)
        } },
        { name: 'paid', showName: 'Paid(CAD)',func:(v,idx,item)=>{
            return  <Box>
            <Typography sx={{color:item.amount < 0?"red":undefined}}>${Number(v)+Number(item.tax)}</Typography>
            <Typography sx={{color:"gray",fontSize:"12px"}}>Price:${item.price}, Tax:{item.course_package.tax*100}%</Typography>
        </Box>
        }},
        { name: 'remained_amount', showName: 'Remained',func:(v,idx,item)=>{
            return <Box>
            <Typography>{v} {item.course_package.billtype==0?"lessons":"minutes"}</Typography>
            <Typography sx={{color:"gray",fontSize:"12px"}}>Total:{item.amount}, Used:{item.used_amount}, Refund:{item.refund_amount}</Typography>
        </Box>
        }},
        { name: 'expired_date', showName: 'Expired Date',func:(v,idx,item)=>{
            return v
        }},
        {
            name: 'option', showName: 'Orders', func: (v, idx, item) => {
                return <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">
                    {/* <Button variant={item.status == 0 ? "outlined" : "contained"} onClick={() => item.status != 0 ? handleDelete(idx, item) : handleEnable(idx, item)}>{item.status == 0 ? 'Disable' : 'Enable'}</Button> */}
                    <Tooltip title="View orders"><IconButton disabled={item.remained_amount == 0} size={"small"} onClick={() => handleRefund(idx, item)}><CurrencyExchangeOutlined fontSize="small"/></IconButton></Tooltip>
                </ButtonGroup>
            }
        },
    ]

    return (
        <Box sx={props.sx}>
            {title && <Typography sx={{mb:1}}>{title}</Typography>}
            {orders && orders.length == 0 && <Alert severity={"info"}>Ops! There is not any data</Alert>}
            {error && <Alert severity={"error"}>{error}</Alert>}
            {orders && orders.length > 0 && <MyTable
                height={650}
                rows={orders}
                totalRow={orders.length}
                headers={TableHeader}
                checkbox={false}
                rowsPerPage={orders.length}                    
            />}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </Box>
    )
}

export default CourseOrder